import React from 'react';

export default function KixxHaziran2026() {
  return (
    <div className="p-6 max-w-7xl mx-auto space-y-16">

      {/* ═══════════════════════════════════════════════════════════════════════ */}
      {/* KIXX — ₺100,000 — Haziran 2026 (Revize)                                 */}
      {/* 3 hedef kitle içerik kurgusu: Kadın · Wellness(Dark) · Erkek            */}
      {/* Her kitlede Video+Lead + ayrı Etkileşim satırı  ·  Google Search         */}
      {/* ═══════════════════════════════════════════════════════════════════════ */}
      <div className="bg-white rounded-2xl shadow-sm border overflow-hidden">
        <div className="bg-white border-b p-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-4">
            <div className="rounded-lg bg-gray-900 px-3 py-2">
              <img src="/kixx/img/kixx-logo-white.png" alt="KIXX" className="h-7 w-auto object-contain" />
            </div>
            <div className="ml-1">
              <h2 className="text-lg font-bold text-gray-800">KIXX — Haziran 2026 Medya Planı <span className="text-sm font-medium text-gray-400">(Revize)</span></h2>
              <p className="text-sm text-gray-500">3 Hedef Kitle • Kadın · Wellness (Dark) · Erkek • Video + Lead + Etkileşim • Google Search</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center px-3 py-1 bg-gray-100 text-gray-600 text-xs font-medium rounded-full border border-gray-200">
              Haziran 2026
            </span>
            <span className="inline-flex items-center px-3 py-1.5 bg-gray-800 text-white text-sm font-semibold rounded-full">
              Total: ₺100,000
            </span>
          </div>
        </div>

        <div className="p-6">
          {/* Kampanya Odağı */}
          <div className="mb-6 p-4 rounded-xl bg-cyan-50 border border-cyan-200">
            <p className="text-xs font-semibold text-cyan-800 mb-1">Haziran Odağı — 3 Hedef Kitle İçerik Kurgusu</p>
            <p className="text-[11px] text-cyan-700 leading-relaxed">
              Yeni dönem iletişiminde <strong>3 ayrı içerik kurgusu</strong> kendi hedef kitlesiyle eşleştirildi:
              <strong> Kadın</strong>, <strong>Wellness &amp; Sauna &amp; Havuz</strong> ve <strong>Erkek</strong>.
              Wellness içeriği <strong>dark (atmosferik) kreatif</strong> tarzında kurgulanıyor; ayrıca bir wellness videosu da
              <strong> post (feed paylaşımı)</strong> olarak yayınlanıyor. Her kitlede ana <strong>Video + Lead (12 taksit)</strong> kampanyasının yanına,
              Hupalupa'da olduğu gibi içerikleri <strong>etkileşim (engagement)</strong> hedefiyle de açan ayrı bir bütçe satırı eklendi —
              yorum / paylaşım / kaydetme ve video izlenme havuzu büyütülerek lead kampanyalarına retargeting kaynağı oluşturuluyor.
            </p>
          </div>

          {/* Budget Split Summary */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
            <div className="rounded-xl border border-indigo-100 bg-indigo-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/6033716.png" alt="Meta" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-indigo-700">Meta Ads</span>
              </div>
              <p className="text-xl font-bold text-indigo-800">₺80,000</p>
              <p className="text-[10px] text-indigo-600 mt-0.5">80% • 3 Kitle + Etkileşim</p>
            </div>
            <div className="rounded-xl border border-blue-100 bg-blue-50 p-4">
              <div className="flex items-center gap-2 mb-1">
                <img src="/google_ads-512.webp" alt="Google" className="w-5 h-5 object-contain" />
                <span className="text-xs font-medium text-blue-700">Google Ads</span>
              </div>
              <p className="text-xl font-bold text-blue-800">₺20,000</p>
              <p className="text-[10px] text-blue-600 mt-0.5">20% • Search (Generic)</p>
            </div>
            <div className="rounded-xl border border-pink-100 bg-pink-50 p-4">
              <span className="text-xs font-medium text-pink-700">Etkileşim</span>
              <p className="text-xl font-bold text-pink-800">₺20,000</p>
              <p className="text-[10px] text-pink-600 mt-0.5">3 kitle ayrı • ~46K etkileşim</p>
            </div>
            <div className="rounded-xl border border-gray-200 bg-gray-50 p-4">
              <span className="text-xs font-medium text-gray-700">Total Clicks</span>
              <p className="text-xl font-bold text-gray-800">13.7K</p>
              <p className="text-[10px] text-gray-600 mt-0.5">Meta 10.6K + Google 3.1K</p>
            </div>
          </div>

          {/* Campaign Plan Table */}
          <div className="rounded-xl border overflow-hidden mb-8">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Campaign Plan — KIXX Haziran 2026 (3 Hedef Kitle)</div>
            <div className="overflow-x-auto">
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Platform / Kitle</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Kampanya / Format</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Reach</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Clicks</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Etkileşim</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Birim (CPC/CPE)</th>
                    <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Budget</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100">

                  {/* ─── KADIN ─────────────────────────────────────────── */}
                  <tr className="bg-rose-50">
                    <td colSpan={7} className="px-4 py-2 text-xs font-semibold text-rose-700 uppercase tracking-wide">
                      <div className="flex items-center gap-2">
                        <img src="/6033716.png" alt="Meta" className="w-4 h-4 object-contain" />
                        Kadın Hedef Kitle — ₺26,000
                      </div>
                    </td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm text-gray-400">└</td>
                    <td className="px-4 py-3 text-sm">Video + Lead (12 Taksit)</td>
                    <td className="px-4 py-3 text-sm text-right">95,000</td>
                    <td className="px-4 py-3 text-sm text-right">3,636</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">₺5.5 CPC</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺20,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm text-gray-400">└</td>
                    <td className="px-4 py-3 text-sm">Etkileşim (Engagement)</td>
                    <td className="px-4 py-3 text-sm text-right">92,000</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">14,300</td>
                    <td className="px-4 py-3 text-sm text-right">₺0.42 CPE</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺6,000</td>
                  </tr>

                  {/* ─── WELLNESS (DARK) ───────────────────────────────── */}
                  <tr className="bg-slate-800">
                    <td colSpan={7} className="px-4 py-2 text-xs font-semibold text-white uppercase tracking-wide">
                      <div className="flex items-center gap-2">
                        <img src="/6033716.png" alt="Meta" className="w-4 h-4 object-contain" />
                        Wellness &amp; Sauna &amp; Havuz — Dark Kurgu ⭐ — ₺30,000
                      </div>
                    </td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm text-gray-400">└</td>
                    <td className="px-4 py-3 text-sm">Video + Lead (Dark Tanıtım)</td>
                    <td className="px-4 py-3 text-sm text-right">105,000</td>
                    <td className="px-4 py-3 text-sm text-right">4,000</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">₺5.5 CPC</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺22,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm text-gray-400">└</td>
                    <td className="px-4 py-3 text-sm">Etkileşim (Wellness Post + Dark Video)</td>
                    <td className="px-4 py-3 text-sm text-right">115,000</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">19,000</td>
                    <td className="px-4 py-3 text-sm text-right">₺0.42 CPE</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺8,000</td>
                  </tr>

                  {/* ─── ERKEK ─────────────────────────────────────────── */}
                  <tr className="bg-sky-50">
                    <td colSpan={7} className="px-4 py-2 text-xs font-semibold text-sky-700 uppercase tracking-wide">
                      <div className="flex items-center gap-2">
                        <img src="/6033716.png" alt="Meta" className="w-4 h-4 object-contain" />
                        Erkek Hedef Kitle — ₺24,000
                      </div>
                    </td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm text-gray-400">└</td>
                    <td className="px-4 py-3 text-sm">Video + Lead (12 Taksit)</td>
                    <td className="px-4 py-3 text-sm text-right">80,000</td>
                    <td className="px-4 py-3 text-sm text-right">3,000</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">₺6.0 CPC</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺18,000</td>
                  </tr>
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm text-gray-400">└</td>
                    <td className="px-4 py-3 text-sm">Etkileşim (Engagement)</td>
                    <td className="px-4 py-3 text-sm text-right">85,000</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">13,300</td>
                    <td className="px-4 py-3 text-sm text-right">₺0.45 CPE</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺6,000</td>
                  </tr>

                  {/* Meta Total */}
                  <tr className="bg-indigo-50 font-semibold">
                    <td className="px-4 py-3 text-sm text-indigo-800" colSpan={2}>Meta Total — 3 Kitle + Etkileşim</td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">10,636</td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">46,600</td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-indigo-800">₺80,000</td>
                  </tr>

                  {/* ─── GOOGLE ────────────────────────────────────────── */}
                  <tr className="hover:bg-gray-50">
                    <td className="px-4 py-3 text-sm font-medium">
                      <div className="flex items-center gap-2">
                        <img src="/google_ads-512.webp" alt="Google Ads" className="w-5 h-5 object-contain" />
                        <span>Google Ads</span>
                      </div>
                    </td>
                    <td className="px-4 py-3 text-sm">Search (Generic — Spor / Üyelik / Taksit)</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">3,077</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">₺6.5 CPC</td>
                    <td className="px-4 py-3 text-sm text-right font-medium">₺20,000</td>
                  </tr>
                  <tr className="bg-blue-50 font-semibold">
                    <td className="px-4 py-3 text-sm text-blue-800" colSpan={2}>Google Total</td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">3,077</td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">-</td>
                    <td className="px-4 py-3 text-sm text-right text-blue-800">₺20,000</td>
                  </tr>

                  {/* Grand Total */}
                  <tr className="bg-gray-800 text-white font-bold">
                    <td className="px-4 py-3 text-sm" colSpan={2}>Grand Total</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">13,713</td>
                    <td className="px-4 py-3 text-sm text-right">46,600</td>
                    <td className="px-4 py-3 text-sm text-right">-</td>
                    <td className="px-4 py-3 text-sm text-right">₺100,000</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Hedefleme & Strateji */}
          <div className="rounded-xl border overflow-hidden mb-8">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Hedefleme & Strateji — 3 Hedef Kitle</div>
            <div className="p-5 grid grid-cols-1 md:grid-cols-3 gap-4 text-[12px] text-gray-700">
              <div className="rounded-lg border border-rose-100 bg-rose-50/40 p-3">
                <p className="font-semibold text-rose-800 mb-1">Kadın</p>
                <p className="leading-relaxed">22-45 yaş kadın; pilates / reformer / grup dersleri / wellness ilgi alanları. Sağlıklı yaşam ve estetik tonunda video + 12 taksit lead. Etkileşim kampanyası ile organik görünürlük ve kadın retargeting havuzu büyütülür.</p>
              </div>
              <div className="rounded-lg border border-slate-300 bg-slate-800/5 p-3">
                <p className="font-semibold text-slate-800 mb-1">Wellness &amp; Sauna &amp; Havuz — Dark ⭐</p>
                <p className="leading-relaxed">25-50 yaş, üst gelir; sauna + havuz + spa deneyimi. Atmosferik <strong>dark kreatif</strong> ile premium konumlandırma. Ayrı bir wellness videosu <strong>post</strong> olarak yayınlanır; etkileşim bütçesi marka algısını ve izlenme havuzunu besler (track içinde en yüksek pay).</p>
              </div>
              <div className="rounded-lg border border-sky-100 bg-sky-50/40 p-3">
                <p className="font-semibold text-sky-800 mb-1">Erkek</p>
                <p className="leading-relaxed">20-45 yaş erkek; fonksiyonel antrenman / power / ağırlık / BioCircuit. Performans odaklı video + 12 taksit lead. Etkileşim ile erkek kitlede reach + izlenme havuzu oluşturulur.</p>
              </div>
            </div>
            <div className="px-5 pb-5 grid grid-cols-1 md:grid-cols-2 gap-4 text-[12px] text-gray-700">
              <div>
                <p className="font-semibold text-gray-800 mb-1">Etkileşim → Lead Hunisi</p>
                <p className="leading-relaxed">Her kitlede etkileşim kampanyaları (yorum / paylaşım / kaydetme / video %50+ izlenme) ucuz erişimle havuz büyütür; bu havuzlar ilgili kitlenin Video + Lead kampanyalarına <strong>retargeting kaynağı</strong> olur — Hupalupa modeliyle aynı mantık.</p>
              </div>
              <div>
                <p className="font-semibold text-gray-800 mb-1">Generic Search Talep Yakalama</p>
                <p className="leading-relaxed">"Spor salonu", "fitness üyelik", "taksitli üyelik", "sauna / havuzlu spor salonu" gibi yüksek niyetli aramalar; lokasyon kısıtlı (kulüp çevresi), dönüşüm (form) odaklı teklif stratejisi.</p>
              </div>
            </div>
          </div>

          {/* Disclaimer */}
          <div className="p-4 rounded-xl bg-amber-50 border border-amber-200">
            <div className="flex items-start gap-2.5">
              <div className="flex-shrink-0 mt-0.5">
                <svg className="w-4 h-4 text-amber-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                </svg>
              </div>
              <div>
                <p className="text-xs font-semibold text-amber-800">Tahmini Performans Projeksiyonları</p>
                <p className="text-[11px] text-amber-700 mt-1 leading-relaxed">
                  Bu plan, içerikler hazır olduğunda hızlı yayına geçebilmek için ön hazırlık olarak hazırlanmıştır ve Türkiye dijital reklam pazarındaki güncel benchmark'lara dayalı tahmini projeksiyonlar içerir.
                  Kurgu, 3 hedef kitleye (Kadın · Wellness Dark · Erkek) ayrılmış içeriklere ve her kitlede ayrı etkileşim bütçesine göre yapılandırılmıştır.
                  Gerçek sonuçlar; açık artırma dinamikleri, hedef kitle davranışı, mevsimsellik, kreatif performansı ve pazar koşullarına bağlı olarak değişiklik gösterebilir.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  );
}
